/**
 * 给 url 或 path 添加 ref 参数
 * @param url 原始 url 或 path
 * @param refValue ref 参数的值
 * @returns 添加了 ref 参数的新 url
 */
export const trackUrlRef = (url: string = '', refValue: string = ''): string => {
  try {
    // 判断是否为绝对 URL
    const hasOrigin = /^https?:\/\//.test(url)
    if (hasOrigin) {
      const u = new URL(url)
      // 如果已有 ref 参数，跳过覆盖
      if (u.searchParams.has('ref')) {
        return url
      }
      u.searchParams.set('ref', refValue)
      return u.toString()
    } else {
      const [pathWithQuery, hash = ''] = url.split('#')
      const [path, query = ''] = pathWithQuery.split('?')
      const params = new URLSearchParams(query)
      // 如果已有 ref 参数，跳过覆盖
      if (params.has('ref')) {
        return url
      }
      params.set('ref', refValue)
      const queryString = params.toString() ? `?${params.toString()}` : ''
      const hashString = hash ? `#${hash}` : ''
      return `${path}${queryString}${hashString}`
    }
  } catch (e) {
    // 如果已有 ref 参数，跳过覆盖
    if (/[?&]ref=/.test(url)) {
      return url
    }
    if (url?.includes('?')) {
      return url + '&ref=' + encodeURIComponent(refValue)
    }
    return url + '?ref=' + encodeURIComponent(refValue)
  }
}
